import LandingPageWrapper from '../components/HomePage/LandingPageWrapper'
import FeatureAffiliate from '../components/LandingPages/JoinAffiliate/Features'
import SectionHeading from '../components/HomePage/SectionHeading'
import HowItWorks1 from '../Icons/landingpages/JoinAffiliate/HowItWorks/1.svg'
import HowItWorks2 from '../Icons/landingpages/JoinAffiliate/HowItWorks/2.svg'
import HowItWorks3 from '../Icons/landingpages/JoinAffiliate/HowItWorks/3.svg'
import HowItWorks4 from '../Icons/landingpages/JoinAffiliate/HowItWorks/4.svg'
import HowItWorks5 from '../Icons/landingpages/JoinAffiliate/HowItWorks/5.svg'
import Hero from '../components/LandingPages/JoinAffiliate/Hero'
import ShallowHeader from '../components/ShallowHeader'
import OLMLogoWhite from '../Icons/HomePage/olm-logo-white.svg'
import Benefits from '../components/LandingPages/JoinAffiliate/Benefits'
import ContactSection from '../components/LandingPages/JoinAffiliate/Contact'
import { ContainerWrapper } from '../components/Container'
import { useRef } from 'react'
import EmbedHubSpotForm from '../components/EmbedHubSpotForm'
import { GeneralAPI } from '../apis/GeneralAPI'

const howItWorks = [
    {
        Icon: HowItWorks1,
        heading: 'Sign Up',
        description:
            'Complete the simple registration form to apply our program.',
    },
    {
        Icon: HowItWorks2,
    },
    {
        Icon: HowItWorks3,
        heading: 'Get Your Unique Affiliate Link',
        description:
            "After approval, you'll receive a unique affiliate link to start promoting.",
    },
    {
        Icon: HowItWorks4,
    },
    {
        Icon: HowItWorks5,
        heading: 'Share and Earn',
        description:
            'Use your link to share Open Letter Marketing with your network. Earn commissions on every referral.',
    },
]

const AffiliateProgram = ({ data }) => {
    const formRef = useRef(null)

    const handleApplyNow = () => {
        if (formRef.current) {
            formRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }

    return (
        <LandingPageWrapper paddingFromTop={false} sectionSpacing={false}>
            <ShallowHeader
                metaTitle={'Join Affiliate Program'}
                meta={data?.yoast_head}
            />

            <div className="space-y-10 md:space-y-10">
                <Hero onApplyClick={handleApplyNow} />

                <div className="bg-light-yellow-gradient-transparent py-16 pb-0 rounded-10xl">
                    <div className="m-auto">
                        <FeatureAffiliate
                            onApplyClick={handleApplyNow}
                            bulletSeperateDesc={true}
                            alignment={'left'}
                            callAction={true}
                        />
                    </div>
                    <div className="m-auto space-y-10 mt-40 px-4 sm:px-6 lg:px-8 ">
                        <SectionHeading size="xl">How it works</SectionHeading>
                        <div className="flex flex-col sm:flex-row items-top m-auto max-w-5xl space-y-4 sm:space-y-0 sm:space-x-4">
                            {howItWorks.map((Item, index) => {
                                const widthClass =
                                    index % 2 === 0
                                        ? 'w-full sm:w-3/12'
                                        : 'sm:w-2/12 pt-28 hidden md:block'
                                return (
                                    <div
                                        key={index}
                                        className={`text-center ${widthClass}`}>
                                        <Item.Icon />
                                        {Item.heading && (
                                            <div className="space-y-4">
                                                <p className="relative font-bold">
                                                    {Item.heading}
                                                </p>
                                                <p>{Item.description}</p>
                                            </div>
                                        )}
                                    </div>
                                )
                            })}
                        </div>
                    </div>

                    <div
                        ref={formRef}
                        className="max-w-xl m-auto mt-20 space-y-10">
                        <SectionHeading size="xl">
                            <p className="hidden md:block">
                                <p>Sign Up Below to Apply to the</p>
                                <p>
                                    {' '}
                                    <span className="olm-gradient-text">
                                        {' '}
                                        Open Letter Marketing{' '}
                                    </span>{' '}
                                    Affiliate Program
                                </p>
                            </p>
                        </SectionHeading>

                        <div className="md:hidden">
                            <SectionHeading size="xl">
                                <p className="md:hidden block">
                                    <p className="space-x-2 text-4xl w-10/12 m-auto">
                                        <p className="space-x-1">
                                            <span>
                                                Sign Up Below to Join the
                                            </span>
                                            <span className="olm-gradient-text">
                                                Open Letter Marketing
                                            </span>
                                        </p>
                                        <p>Affiliate Program</p>
                                    </p>
                                </p>
                            </SectionHeading>
                        </div>

                        <div className="flex justify-center items-center">
                            <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
                                <EmbedHubSpotForm
                                    region="na1"
                                    portalId="21994206"
                                    formId="8b85d11d-0eea-4651-96b8-a2c583650d0d"
                                    formName="Join Affiliate Program"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <Benefits onApplyClick={handleApplyNow} size="xl" />

                <ContactSection onApplyClick={handleApplyNow} />

                <footer className="flex pt-10 justify-center items-center bg-olm-gradient-t-to-b py-10 px-0 rounded-[100px] rounded-b-none text-white">
                    <ContainerWrapper>
                        <div className="text-center space-y-6 w-full">
                            <div className="flex justify-center mb-2">
                                <OLMLogoWhite />
                            </div>
                            <hr className="border-white w-full" />
                            <p className="text-sm">
                                © 2024 Open Letter Marketing, Inc. All Rights
                                Reserved.
                            </p>
                        </div>
                    </ContainerWrapper>
                </footer>
            </div>
        </LandingPageWrapper>
    )
}

export async function getStaticProps() {
    const page = await GeneralAPI.getPageBySlug('/join-affiliate-program')
    const data = page ? page[0] : {}
    return {
        props: {
            isComponent: true,
            data,
        },
        revalidate: 10, // In seconds
    }
}

export default AffiliateProgram
